import { SubMeteringSystem } from "../../../types/api.types";
import type { MeterConfigurationData } from "../ThirdPartySystems.types";

export function getParameterName(
  systemName: SubMeteringSystem,
  parameter?: MeterConfigurationData
): string {
  let parameterName = "Unbekannt";

  if (parameter) {
    switch (systemName) {
      case SubMeteringSystem.Qivalo:
        if ("propertyName" in parameter.parameters) {
          parameterName = parameter.parameters.propertyName;
        }
        return parameterName;
      case SubMeteringSystem.WisSoftenergy:
        if ("parkName" in parameter.parameters) {
          parameterName = parameter.parameters.parkName;
        }
        return parameterName;
      case SubMeteringSystem.RotorsoftDrehpunkt:
      case SubMeteringSystem.WeoBytemee:
        if ("windparkName" in parameter.parameters) {
          parameterName = parameter.parameters.windparkName;
        }
        return parameterName;
      case SubMeteringSystem.BreezeGreenbyte:
        if ("siteName" in parameter.parameters) {
          parameterName = parameter.parameters.siteName;
        }
        return parameterName;
      case SubMeteringSystem.NavigatorSiemens:
      case SubMeteringSystem.WonderWindguard:
        if ("name" in parameter.parameters) {
          parameterName = parameter.parameters.name;
        }
        return parameterName;
      case SubMeteringSystem.Wattline:
      case SubMeteringSystem.Metiundo:
        if ("serialNumber" in parameter.parameters) {
          parameterName = parameter.parameters.serialNumber;
        }
        return parameterName;
      default:
        return parameterName;
    }
  }

  return parameterName;
}
